import toPLN from "../global/toPLN";
import useRole from "../../hooks/useRole";

export default function ProductScore({data}) {
    const role = useRole();
    const { name, volume, netto, margin, clients, basket, color } = data;
    return (
        <div className="product-score">
            <div className="score-titles">
                <h6 style={{borderLeft: `3px solid ${color}`}}><span style={{paddingLeft: '3px'}}>{name}</span></h6>
                <h5>{volume.toFixed(2)} l</h5>
            </div>
            <table>
                <tbody>
                    {role !== 'supply' && (
                        <tr>
                            <th>Marża jedn:</th>
                            <td>{toPLN(margin / volume) || '0'}</td>
                        </tr>
                    )}
                    {role !== 'supply' && (
                        <tr>
                            <th>Marża kwotowa:</th>
                            <td>{toPLN(margin)}</td>
                        </tr>
                    )}
                    <tr>
                        <th>Ilość klientów:</th>
                        <td>{clients}</td>
                    </tr>
                    <tr>
                        <th>Średni koszyk:</th>
                        <td>{toPLN(basket)}</td>
                    </tr>
                    <tr>
                        <th>Sprzedaż netto:</th>
                        <td>{toPLN(netto)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
